export function parseJwtToken(token: string) {
  const [, base64Payload] = token.split('.');
  const payload = atob(base64Payload);

  return JSON.parse(payload.toString());
}
